<template lang="pug">
  #wrapper
    Header
    main
      #title ホーム

      .card
        .card-item
          span.cart-item__title 医院情報
          router-link(to="./clinic/add/")
            btnM(btnTxt="新規追加" color="primary" class="cart-item__btn")
          router-link(to="./clinic/")
            btnM(btnTxt="一覧" color="neutral" class="cart-item__btn")
        .card-item
          span.cart-item__title NEWS（一般）
          router-link(to="./news/add/1")
            btnM(btnTxt="新規追加" color="primary" class="cart-item__btn")
          router-link(to="./news/1")
            btnM(btnTxt="一覧" color="neutral" class="cart-item__btn")
        .card-item
          span.cart-item__title NEWS（医療関係者）
          router-link(to="./news/add/2")
            btnM(btnTxt="新規追加" color="primary" class="cart-item__btn")
          router-link(to="./news/2")
            btnM(btnTxt="一覧" color="neutral" class="cart-item__btn")
        //-.card-item
          span.cart-item__title セミナー
          router-link(to="")
            btnM(btnTxt="新規追加" color="primary" class="cart-item__btn")
          router-link(to="")
            btnM(btnTxt="一覧" color="neutral" class="cart-item__btn")
</template>

<script>
import API from "@/lib/api";
import common from "@/lib/common.js";
import Header from "@/components/headerC";
import btnM from "@/components/common/btnM";
export default {
  name: "HomeView",
  metaInfo() {
    return {
      title: "DIOデジタル株式会社",
      meta: [
        { name: "description", content: "" },
        { name: "keywords", content: "" },
      ],
    };
  },
  mixins: [common],
  components: {
    Header,
    btnM,
  },
  data: function () {
    return {
      data: "dataは初期値",
    };
  },
  mounted() {},
  methods: {
    async getItem() {
      console.log("getItem()");
      const api = new API();
      let data = await api.get("/article/1/1", null, null, false);
      console.log(data);
    },
  },
  async created() {
    this.getItem();
    this.windowTop();
    this.loginCheck();
  },
};
</script>

<style lang="scss">
@use "@/css/utility/_colors" as colors;
@use "@/css/utility/_mixin" as mixin;
@use "@/css/utility/_media" as media;
@use "@/css/utility/_font" as font;
@use "@/css/utility/_variables" as variables;
.card-item {
  background: #fcfcfc;
  border-radius: 24px;
  width: 100%;
  box-sizing: border-box;
  padding: 30px;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.cart-item__title {
  width: 200px;
  font-size: 15px;
  font-weight: 700; /* bold */
  letter-spacing: 0.05em;
}

.cart-item__btn {
  margin-right: 30px;
}
</style>
